<footer class="main-footer">
  <div class="flex justify-center items-center">
    @if (isExternal) {
      <p>
        To learn more about Carelon services contact us!
        <a [href]="portalSupportLink" target= "_blank" class="no-underline p-button-link">
          Portal Support
        </a>
      </p>
    } @else {
      <p>
        NexLync:
        <a [href]="reportAnIssueLink" target= "_blank" class="no-underline p-button-link">
          Report an Issue
        </a>
      </p>
    }
  </div>
</footer>
